<template>
  <v-timeline v-if="valid">
    <template v-for="revision in items">
      <v-timeline-item class="mb-4" color="grey" icon-color="grey lighten-2" small :key="revision.changeTime" right>
        <template v-slot:opposite>
          <span>
            <b v-if="isInitialSnapshot(revision)">INITIAL SNAPSHOT </b>
            <b v-else>{{ renderChangeType(revision.changeType) }} </b>
            <br />
            {{ revision.changeTime | formatDateClient("MM/DD/YYYY hh:mm a z", selectedClient) }}
            <br />
            ({{ revision.changeTime | formatDateFromNow }})
            <span v-if="revision.changedByUsername"> <br />by {{ revision.changedByFullName }}</span>
          </span>
        </template>

        <v-card v-if="isInitialSnapshot(revision)">
          <span>
            This snapshot was generated automatically because no previous audit existed.
          </span>
        </v-card>
        <v-card v-else class="elevation-2">
          <v-card-text>
            The following fields were
            <span v-if="revision.changeType === 'ADD'">added:</span>
            <span v-else-if="revision.changeType === 'MOD'">updated:</span>
            <span v-else-if="revision.changeType === 'DEL'">deleted:</span>
            <ul>
              <li v-for="(value, index) in revision.revisionChanges" :key="index">
                <b>{{ renderValue(value.fieldDisplayName) }}</b>
                <span v-if="revision.changeType === 'MOD' || revision.changeType === 'DEL'">
                  from <code>{{ renderValue(value.fromValue) }}</code>
                </span>
                to
                <code>{{ renderValue(value.toValue) }}</code>
              </li>
            </ul>
          </v-card-text>
        </v-card>
      </v-timeline-item>
    </template>
    <v-timeline-item class="mb-4" hide-dot v-if="items && items.length > 0">
      <v-btn v-if="!isLastPage" @click="showMore">Show more</v-btn>
    </v-timeline-item>
  </v-timeline>
</template>

<script>
import { mapGetters } from "vuex";
import ApiService from "../../services/api.service";

export default {
  name: "RevisionTimeline",
  props: {
    type: String,
    id: Number
  },
  data: () => ({
    validType: false,
    validId: false,
    dialog: false,
    loading: false,
    itemsNumber: 10,
    isLastPage: false,
    pageNumber: 0,
    items: []
  }),

  computed: {
    ...mapGetters(["selectedParticipant", "selectedClient"]),
    valid() {
      return this.validType && this.validId;
    }
  },

  mounted() {
    this.fetchData();
  },

  methods: {
    renderValue(value) {
      if (value === null || value === undefined) {
        return "NULL";
      } else {
        return value;
      }
    },
    renderChangeType(changeType) {
      switch (changeType) {
        case "ADD":
          return "ADDITION";
        case "MOD":
          return "UPDATE";
        case "DEL":
          return "DELETION";
        default:
          return changeType;
      }
    },
    fetchData() {
      if (!this.valid) {
        return;
      }
      this.loading = true;

      let filters = {};
      if (this.search && this.search.length > 0) {
        filters.keyword = this.search;
      }
      if (this.id) {
        filters[this.type] = { id: this.id };
      }

      return ApiService.get(
        `/api/${this.type}s/${this.id}/revisions?size=${this.itemsNumber}&page=${this.pageNumber}`,
        filters
      )
        .then(({ data }) => {
          this.isLastPage = data.totalPages == this.pageNumber + 1;
          this.loading = false;
          this.items = this.items.concat(data.content);
          return Promise.resolve(data);
        })
        .catch(e => {
          this.loading = false;
          return Promise.reject(e);
        });
    },
    showMore() {
      this.pageNumber += 1;
      this.fetchData();
    },

    isInitialSnapshot(revision) {
      const initialSnapshots = this.items.filter(
        r =>
          r.changeType === "MOD" && r.revisionChanges.length > 0 && r.revisionChanges.every(c => c.fromValue === null)
      );
      const firstSnapshot = initialSnapshots.length > 0 ? initialSnapshots[0] : null;
      return firstSnapshot && revision.changeTime === firstSnapshot.changeTime;
    }
  },
  watch: {
    type: {
      immediate: true,
      handler(v) {
        switch (v) {
          case "participant":
          case "organization":
          case "sale":
          case "user":
          case "promotion":
          case "customReport":
          case "productRegistration":
            this.validType = true;
            break;
          default:
            this.validType = false;
            console.log("No revision type found");
            break;
        }
      }
    },
    id: {
      immediate: true,
      handler(v) {
        if (!v || isNaN(v)) {
          this.validId = false;
        }
        this.validId = true;
      }
    }
  }
};
</script>
